<template>
  <div class="staff-app-auth-manage-container">
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('staffAppAuthManage.title') }}</span>
        <div class="card-header-actions">
          <el-button type="success" size="small" @click="_openCommonQrCodeModal">
            <i class="el-icon-full-screen"></i> 通用认证二维码
          </el-button>
          <el-button type="primary" size="small" @click="_refreshStaffAppAuth">
            <i class="el-icon-refresh"></i> {{ $t('common.refresh') }}
          </el-button>
        </div>
      </div>

      <el-row :gutter="20">
        <el-col :span="24">
          <el-table :data="staffAppAuthManageList" border style="width: 100%" v-loading="loading">
            <el-table-column prop="staffName" :label="$t('staffAppAuthManage.staffName')" align="center" />
            <el-table-column prop="appType" :label="$t('staffAppAuthManage.authType')" align="center">
              <template slot-scope="scope">
                {{ scope.row.appType === '-' ? '-' : 'WECHAT' }}
              </template>
            </el-table-column>
            <el-table-column prop="openName" :label="$t('staffAppAuthManage.authName')" align="center" />
            <el-table-column prop="openId" :label="$t('staffAppAuthManage.authId')" align="center" />
            <el-table-column :label="$t('staffAppAuthManage.authStatus')" align="center">
              <template slot-scope="scope">
                <el-tag :type="scope.row.state === '2002' ? 'success' : 'info'" size="small">
                  {{ scope.row.stateName }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" :label="$t('staffAppAuthManage.authTime')" align="center">
              <template slot-scope="scope">
                {{ scope.row.createTime || '-' }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('common.operation')" align="center" width="150">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" :disabled="scope.row.state === '2002'" @click="_openAddStaffAppAuthModal(scope.row)">
                  {{ $t('staffAppAuthManage.auth') }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>

      <el-pagination
        class="pagination-wrapper"
        :current-page.sync="page.current"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="page.size"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange">
      </el-pagination>

      <add-staff-app-auth ref="addStaffAppAuth" @success="_refreshStaffAppAuth" />

      <!-- 通用认证二维码弹窗 -->
      <el-dialog title="通用认证二维码" :visible.sync="commonQrCodeVisible" width="400px" @close="_closeCommonQrCode">
        <div class="common-qrcode-container">
          <p class="common-qrcode-tip">员工使用微信扫码后，进入员工端登录页，输入账号密码登录后将自动完成微信认证绑定。</p>
          <div id="commonQrcode" class="common-qrcode-box"></div>
          <p v-if="commonQrCodeUrl" class="common-qrcode-url">扫码URL：<br/><span>{{ commonQrCodeUrl }}</span></p>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { queryStaffAppAuth, generatorQrCode } from '@/api/staff/staffAppAuthManageApi'
import AddStaffAppAuth from '@/components/staff/addStaffAppAuth'
import QRCode from 'qrcodejs2'

export default {
  name: 'StaffAppAuthManageList',
  components: {
    AddStaffAppAuth
  },
  data() {
    return {
      loading: false,
      staffAppAuthManageList: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      commonQrCodeVisible: false,
      commonQrCodeUrl: ''
    }
  },
  created() {
    this._listStaffAppAuths()
  },
  methods: {
    async _listStaffAppAuths() {
      try {
        this.loading = true
        const params = {
          page: this.page.current,
          row: this.page.size
        }
        const res = await queryStaffAppAuth(params)
        this.page.total = res.total || 0
        if (Array.isArray(res.data)) {
          this.staffAppAuthManageList = res.data
        } else {
          this.staffAppAuthManageList = res.data ? [res.data] : []
        }
      } catch (error) {
        this.$message.error(this.$t('staffAppAuthManage.fetchError'))
      } finally {
        this.loading = false
      }
    },
    handleSizeChange(val) {
      this.page.size = val
      this.page.current = 1
      this._listStaffAppAuths()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this._listStaffAppAuths()
    },
    _openAddStaffAppAuthModal(row) {
      this.$refs.addStaffAppAuth.open(row)
    },
    _refreshStaffAppAuth() {
      this._listStaffAppAuths()
    },
    async _openCommonQrCodeModal() {
      this.commonQrCodeVisible = true
      try {
        const { data } = await generatorQrCode({ common: true })
        this.commonQrCodeUrl = data
        this.$nextTick(() => {
          const container = document.getElementById('commonQrcode')
          if (container) {
            container.innerHTML = ''
            // eslint-disable-next-line no-new
            new QRCode(container, {
              text: data,
              width: 240,
              height: 240,
              colorDark: '#000000',
              colorLight: '#ffffff',
              correctLevel: QRCode.CorrectLevel.H
            })
          }
        })
      } catch (error) {
        this.$message.error('生成通用认证二维码失败')
        this.commonQrCodeVisible = false
      }
    },
    _closeCommonQrCode() {
      this.commonQrCodeUrl = ''
      const container = document.getElementById('commonQrcode')
      if (container) {
        container.innerHTML = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.staff-app-auth-manage-container {
  padding: 20px;

  .box-card {
    margin-bottom: 20px;
  }

  .card-header-actions {
    float: right;

    .el-button + .el-button {
      margin-left: 10px;
    }
  }

  .el-table {
    margin-top: 20px;
  }

  .pagination-wrapper {
    margin-top: 20px;
    text-align: right;
  }

  .common-qrcode-container {
    text-align: center;

    .common-qrcode-tip {
      color: #606266;
      font-size: 13px;
      line-height: 1.6;
      margin-bottom: 15px;
    }

    .common-qrcode-box {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto 15px;
      width: 260px;
      height: 260px;
      border: 1px solid #ebeef5;
      padding: 10px;
    }

    .common-qrcode-url {
      color: #909399;
      font-size: 12px;
      word-break: break-all;
      text-align: left;
      background: #f5f7fa;
      padding: 8px;
      border-radius: 4px;

      span {
        color: #606266;
      }
    }
  }
}
</style>
